<template>
	<div>

		<div class="btns-top">
			<a href="#" class="btn btn-submit fa fa-save transition-fadeinup transition-delay-01" v-on:click="clickUpdateClickHandler"></a>
		</div>

		<div class="row">
			<div class="col-12 transition-fadeinup">

				<form v-if="entity">
					<ul>
						<li>
							<label>Name</label> <input type="text" name="translations.en.value" v-model="entity.translations.en.value">
						</li>
						<li>
							<label>Machine name</label> <input type="text" v-model="entity.name" disabled>
							<div class="description">This is automatically generated upon object creation. use this for reference
								columns.
							</div>
						</li>
						<li>
							<label class="flex-label"><input type="checkbox" name="settings.addressable.value" class="toggle" value="true" :checked="this.addressable === 'true'"> addressable</label>
							<div class="description">Automatically generate a url field, meta data & structure item</div>
						</li>
						<li>
							<label class="flex-label"><input type="checkbox" name="settings.autopublish.value" class="toggle" value="true" :checked="this.autopublish === 'true'"> autopublish</label>
						</li>
						<li>
							<label class="flex-label"><input type="checkbox" name="settings.sortable.value" value="true" class="toggle" :checked="this.sortable === 'true'"> sortable</label>
							<div class="description">Enabling this will disable the search functionality for the object</div>
						</li>
						<li>
							<label class="flex-label"><input type="checkbox" name="settings.nestable.value" value="true" class="toggle" :checked="this.nestable === 'true'"> nestable</label>
							<div class="description">This will only work if sortable is active</div>
						</li>
						<li>
							<label>Group</label> <input type="text" name="settings.group.value" v-model="this.group">
							<div class="description">Add a group name to group certain entities together in different quick link blocks on the dashboard</div>
						</li>
					</ul>
				</form>

				<p>&nbsp;</p>

				<!--
				<p>&nbsp;</p>

				<h2>showpad store</h2>
				<p>checking this option will create a global scoped store in showpad to store the data of this object.</p>
				<form>
					<ul>
						<li><label>
								<div class="checker toggle"><span class="checked"><input type="checkbox" class="toggle" checked=""></span>
								</div>
								create showpad store for this object</label></li>
					</ul>
				</form>
				-->

				<a href="#" class="btn red" v-on:click="deleteObjectClickHandler"><span class="fa fa-trash-alt"></span>Delete object</a>

			</div>
		</div>

	</div>
</template>

<script>

import _ from 'lodash/object'
import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'options',
	props: {
		entity: Object
	},
	watch: {
		entity: function (newVal, oldVal) {
			if (newVal.settings.addressable) this.addressable = newVal.settings.addressable.value
			if (newVal.settings.autopublish) this.autopublish = newVal.settings.autopublish.value
			if (newVal.settings.sortable) this.sortable = newVal.settings.sortable.value
			if (newVal.settings.nestable) this.nestable = newVal.settings.nestable.value
			if (newVal.settings.group) this.group = newVal.settings.group.value
		}
	},
	data () {
		return {
			addressable: null,
			autopublish: null,
			sortable: null,
			nestable: null,
			group: null
		}
	},

	created () {
		if (this.entity) {
			if (this.entity.settings.addressable) this.addressable = this.entity.settings.addressable.value
			if (this.entity.settings.autopublish) this.autopublish = this.entity.settings.autopublish.value
			if (this.entity.settings.sortable) this.sortable = this.entity.settings.sortable.value
			if (this.entity.settings.nestable) this.nestable = this.entity.settings.nestable.value
			if (this.entity.settings.group) this.group = this.entity.settings.group.value
		}
	},

	updated () {
	},

	methods: {
		deleteObjectClickHandler (e) {
			e.preventDefault()
			var confirm = window.confirm('Are you sure you want to remove this item?')
			if (!confirm) return

			// set state to 5
			this.entity.state = 5

			var json = JSON.stringify(this.entity)

			var url = '/cms/api/entities'
			xhrModule.post(url, json, this.deletCompletedHandler.bind(this))
		},

		deletCompletedHandler () {
			var pathName = window.location.pathname
			var contentType = pathName.split('/')[1]

			// redirect back to the main slug
			this.$router.push('/' + contentType)
		},

		clickUpdateClickHandler (e) {
			e.preventDefault()

			// gather all data
			var form = document.querySelector('form')
			var formData = new FormData(form)

			var object = {}
			formData.forEach((value, key) => {
				if (!Reflect.has(object, key)) {
					object[key] = value
					return
				}
				if (!Array.isArray(object[key])) {
					object[key] = [object[key]]
				}
				object[key].push(value)
			})

			var merged = {}
			for (var key in object) {
				_.set(merged, key, object[key])
			}

			if (!merged.settings) merged['settings'] = {}
			if (!merged.settings.addressable) {
				merged.settings['addressable'] = {
					'value': 'false'
				}
			}

			if (!merged.settings.autopublish) {
				merged.settings['autopublish'] = {
					'value': 'false'
				}
			}

			if (!merged.settings.sortable) {
				merged.settings['sortable'] = {
					'value': 'false'
				}
			}

			if (!merged.settings.nestable) {
				merged.settings['nestable'] = {
					'value': 'false'
				}
			}

			if (!merged.settings.group) {
				merged.settings['group'] = {
					'value': 'false'
				}
			}

			// set new translation
			this.entity.translations.en.value = merged.translations.en.value

			// settings
			for (var key1 in merged.settings) {
				if (this.entity.settings[key1]) {
					this.entity.settings[key1].value = merged.settings[key1].value
				} else {
					// not defined yet
					this.entity.settings[key1] = {
						'id': 0,
						'name': key1,
						'value': merged.settings[key1].value
					}
				}
			}

			var json = JSON.stringify(this.entity)

			var url = '/cms/api/entities'
			xhrModule.post(url, json, this.updateCompletedHandler.bind(this))
		},

		updateCompletedHandler: function (data) {
			general.saveAnimation()
			this.entity.settings = data.data.settings
		}
	}
}

</script>
